// extracted by mini-css-extract-plugin
export default {"history":"history_history__SEYiU"};